var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstructionLoan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 69V55l-8 14h8z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 52.5H68v17H41v-16M31 22.5v47h-5V68m0-45.5V50M31 18.5l-5-8v8",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.5l8.148-7.696a2 2 0 011.97-.455L66 22.5",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66 22.5H17v-4h35.786L66 22.5zM51 56.5h7v7h-7zM54 23v11.5M26 26.5l5 8.5M26 41l5 8.5M26 34.5l2.5 4",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 59,
    r: 10,
    fill: "#FFF7EE",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.796 61.529a.96.96 0 10-.637 1.813l.637-1.813zm1.43 1.21l.005-.96h-.005v.96zm2.066-1.485l.948.16-.948-.16zm-.618-1.714l.622-.733-.003-.002-.619.735zm-1.71-.551l-.184.943.008.002.177-.945zm-1.336-.674l-.748.604.004.005.744-.609zm-.393-1.48l-.947-.16-.001.006.948.155zm2.067-1.485l-.003.961.003-.96zm1.408 1.203a.96.96 0 10.68-1.797l-.68 1.797zm-3.233 5.883l-.318.906.002.001.005.001.012.005a5.852 5.852 0 00.624.174c.365.085.88.177 1.423.178l.001-1.922c-.342 0-.7-.06-.989-.128a5.538 5.538 0 01-.421-.116l-.02-.006h-.002.001l-.318.906zM17.22 63.7c1.11.006 2.74-.633 3.02-2.286l-1.895-.32c-.03.178-.135.335-.34.467-.219.14-.508.218-.774.217L17.22 63.7zm3.02-2.286a2.819 2.819 0 00-.944-2.608l-1.243 1.466c.223.19.345.51.292.821l1.895.32zm-.947-2.61c-.393-.33-.83-.489-1.199-.581-.327-.083-.748-.141-.952-.18l-.354 1.89c.378.07.575.087.837.154.223.055.348.118.43.188l1.238-1.47zm-2.144-.759c-.45-.088-.663-.2-.777-.34l-1.488 1.218c.56.684 1.351.901 1.896 1.008l.37-1.886zm-.773-.334a.946.946 0 01-.192-.722l-1.897-.309c-.129.79.094 1.62.593 2.238l1.496-1.207zm-.193-.716c.046-.272.152-.407.271-.49.141-.1.401-.197.845-.195l.006-1.922c-.703-.002-1.392.148-1.956.544-.585.411-.94 1.022-1.061 1.742l1.895.32zm1.116-.685a4.517 4.517 0 011.398.238l.015.005h-.001-.001l.34-.9.34-.898-.003-.002-.004-.001-.013-.005a2.365 2.365 0 00-.169-.057 6.435 6.435 0 00-1.896-.302l-.006 1.922z",
    fill: "#7E776E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.448 63.351v1.65M17.463 53l-.003 1.606",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M72 47.5H36l18-13 18 13z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgConstructionLoan;